import Resource from '@/api/resources/Resource'

class IncidentTypeService extends Resource {
    async findAllActiveIncidentTypes(laboratoryId, originId, coreEntity) {
        const params = { incidentOriginId: originId, coreEntity: coreEntity }
        const response = await this.axios.get(`/incident/laboratories/${laboratoryId}/incidentTypes`, { params })
        return response.data.reduce((map, incidentType) => {
            map[incidentType.id] = incidentType
            return map
        }, {})
    }
}
export default new IncidentTypeService()
